import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, addDoc, onSnapshot, query, where, serverTimestamp } from "firebase/firestore";

function TartimPage() {
  const [bekleyenler, setBekleyenler] = useState([]);
  const [seciliMusteri, setSeciliMusteri] = useState(null);
  
  // Ayarlar (Burayı daha sonra yönetim panelinden de kontrol edebiliriz)
  const [fiyatAyarlar, setFiyatAyarlar] = useState({
    minKilo: 20,
    minFiyat: 1000,
    ekstraKgFiyat: 50
  });

  // Tartım State'leri
  const [brut, setBrut] = useState("");
  const [dara, setDara] = useState("");
  const [not, setNot] = useState("");

  const net = (Number(brut) - Number(dara)) || 0;

  // Sıkım Ücreti Hesaplama Mantığı
  const hesaplaSikimBedeli = () => {
    if (net <= 0) return 0;
    if (net <= fiyatAyarlar.minKilo) {
      return fiyatAyarlar.minFiyat;
    } else {
      const ekstraKg = net - fiyatAyarlar.minKilo;
      return fiyatAyarlar.minFiyat + (ekstraKg * fiyatAyarlar.ekstraKgFiyat);
    }
  };

  const sikimBedeli = hesaplaSikimBedeli();

  useEffect(() => {
    const bugun = new Date(); bugun.setHours(0,0,0,0);
    const q = query(collection(db, "kuyruk"), where("tarih", ">=", bugun));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setBekleyenler(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return unsubscribe;
  }, []);

  const tartimKaydet = async () => {
    if (!seciliMusteri || net <= 0) return alert("Lütfen müşteri seçin ve geçerli tartım girin!");

    try {
      await addDoc(collection(db, "tartimlar"), {
        musteriId: seciliMusteri.id,
        musteriAd: seciliMusteri.isim,
        bolge: seciliMusteri.bolge,
        brut: Number(brut),
        dara: Number(dara),
        net: net,
        sikimBedeli: sikimBedeli,
        not: not,
        tarih: serverTimestamp()
      });
      alert("Tartım ve Hesaplama Kaydedildi!");
      setBrut(""); setDara(""); setNot(""); setSeciliMusteri(null);
    } catch (error) {
      alert("Hata oluştu!");
    }
  };

  return (
    <div className="grid grid-cols-12 gap-6 h-full min-h-screen p-2">
      
      {/* SOL: BEKLEYEN LİSTESİ VE DEV LOGO */}
      <div className="col-span-12 md:col-span-4 flex flex-col gap-6">
        <div className="bg-slate-900 p-6 rounded-3xl border border-slate-800 shadow-xl overflow-y-auto max-h-[60vh]">
          <h2 className="text-xl font-black text-blue-500 mb-6 uppercase flex items-center gap-2">
            <span className="w-2 h-8 bg-blue-500 rounded-full"></span>
            Bekleyen Kuyruğu
          </h2>
          <div className="space-y-3">
            {bekleyenler.map(m => (
              <button 
                key={m.id} 
                onClick={() => setSeciliMusteri(m)}
                className={`w-full p-5 rounded-2xl border-2 text-left transition-all relative overflow-hidden group ${seciliMusteri?.id === m.id ? 'border-blue-500 bg-blue-500/10 scale-[1.02]' : 'border-slate-800 bg-slate-800/50 text-slate-400 hover:border-slate-600'}`}
              >
                <div className="flex justify-between items-start relative z-10">
                  <div>
                    <p className="text-[10px] font-black text-blue-400 tracking-widest uppercase mb-1">{m.bolge || "Bölge Belirtilmemiş"}</p>
                    <h3 className="font-black text-white text-lg uppercase leading-tight">{m.isim}</h3>
                    <p className="text-xs font-bold text-slate-500 mt-1 italic">{m.telefon || "Tel Yok"}</p>
                  </div>
                  <span className={`text-xl font-black px-4 py-2 rounded-xl ${seciliMusteri?.id === m.id ? 'bg-blue-500 text-white' : 'bg-slate-950 text-slate-600'}`}>#{m.siraNo}</span>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* DEV LOGO BÖLÜMÜ */}
        <div className="bg-slate-900 flex-1 rounded-3xl border border-slate-800 p-10 flex flex-col items-center justify-center relative overflow-hidden group">
            <div className="absolute inset-0 bg-blue-500/5 blur-[80px] rounded-full group-hover:bg-blue-500/10 transition-all duration-700"></div>
            <img src="/logo.png" alt="Aydın Logo" className="h-40 w-40 object-contain relative z-10 opacity-80 group-hover:scale-110 group-hover:opacity-100 transition-all duration-500" />
            <div className="text-center mt-6 relative z-10">
              <p className="text-3xl font-black uppercase tracking-[0.3em] text-white">AYDIN</p>
              <p className="text-xs font-bold uppercase tracking-[0.4em] text-blue-500 mt-1">Zeytinyağı Fabrikası</p>
            </div>
        </div>
      </div>

      {/* SAĞ: TARTIM VE HESAPLAMA PANELİ */}
      <div className="col-span-12 md:col-span-8 space-y-6">
        <div className="bg-slate-900 p-8 rounded-3xl border border-slate-800 shadow-2xl relative overflow-hidden">
          {/* Müşteri Bilgi Şeridi */}
          <div className="flex justify-between items-center mb-10 border-b border-slate-800 pb-6">
            <div>
              <p className="text-xs font-black text-emerald-500 uppercase tracking-widest mb-1">Şu An İşlemde Olan</p>
              <h2 className="text-4xl font-black text-white uppercase italic tracking-tighter">
                {seciliMusteri ? seciliMusteri.isim : "MÜŞTERİ SEÇİNİZ"}
              </h2>
            </div>
            {seciliMusteri && (
              <div className="text-right">
                <p className="text-xs font-bold text-slate-500 uppercase">📍 Bölge</p>
                <p className="text-xl font-black text-white uppercase">{seciliMusteri.bolge}</p>
              </div>
            )}
          </div>
          
          <div className="grid grid-cols-2 gap-8">
            <div className="space-y-6">
              <div className="group">
                <label className="text-xs font-bold text-slate-500 uppercase ml-2 mb-2 block">Brüt Ağırlık (Kg)</label>
                <input type="number" value={brut} onChange={(e)=>setBrut(e.target.value)} placeholder="000.00" className="w-full bg-slate-950 p-6 rounded-2xl border-2 border-slate-800 focus:border-blue-600 outline-none text-5xl font-black text-white transition-all"/>
              </div>
              <div className="group">
                <label className="text-xs font-bold text-slate-500 uppercase ml-2 mb-2 block">Dara (Boş Kap) (Kg)</label>
                <input type="number" value={dara} onChange={(e)=>setDara(e.target.value)} placeholder="00.00" className="w-full bg-slate-950 p-6 rounded-2xl border-2 border-slate-800 focus:border-emerald-600 outline-none text-5xl font-black text-white transition-all"/>
              </div>
            </div>

            <div className="grid grid-rows-2 gap-4">
              {/* Net Göstergesi */}
              <div className="bg-slate-950 rounded-3xl border border-slate-800 p-6 flex flex-col justify-center items-center relative overflow-hidden">
                <div className="absolute top-0 right-0 p-4 opacity-10 font-black text-6xl">KG</div>
                <p className="text-xs font-bold text-slate-500 uppercase tracking-widest relative z-10">Net Zeytin</p>
                <div className="text-7xl font-black text-emerald-500 my-2 relative z-10 tracking-tighter">{net}</div>
              </div>

              {/* Sıkım Bedeli Göstergesi */}
              <div className="bg-emerald-600/5 rounded-3xl border-2 border-emerald-500/20 p-6 flex flex-col justify-center items-center relative">
                <p className="text-xs font-bold text-emerald-500 uppercase tracking-widest">Sıkım Bedeli (₺)</p>
                <div className="text-6xl font-black text-white my-2 tracking-tighter">
                   {sikimBedeli.toLocaleString('tr-TR')}
                </div>
                <p className="text-[10px] font-bold text-emerald-600 uppercase italic">Minimum {fiyatAyarlar.minKilo}kg / {fiyatAyarlar.minFiyat}₺ Tarifesi</p>
              </div>
            </div>
          </div>

          <div className="mt-10 flex gap-4">
             <div className="relative flex-1">
               <input value={not} onChange={(e)=>setNot(e.target.value)} placeholder="Tartım Notu (Örn: Erken hasat, sızma...)" className="w-full bg-slate-800 p-6 rounded-2xl outline-none border border-slate-700 text-white font-bold"/>
             </div>
             <button 
                onClick={tartimKaydet} 
                disabled={!seciliMusteri || net <= 0}
                className="bg-emerald-600 px-12 rounded-2xl font-black text-2xl hover:bg-emerald-500 disabled:bg-slate-800 disabled:text-slate-600 disabled:cursor-not-allowed transition-all shadow-xl shadow-emerald-900/30"
              >
               KAYDET VE BİTİR
             </button>
          </div>
        </div>

        {/* Küçük Fiyat Bilgilendirme Kartı */}
        <div className="bg-slate-900 p-4 rounded-2xl border border-dashed border-slate-700 flex justify-around text-[10px] font-black text-slate-500 uppercase tracking-widest">
           <span>Min: {fiyatAyarlar.minKilo} KG</span>
           <span>Min Ücret: {fiyatAyarlar.minFiyat} TL</span>
           <span>Ekstra: {fiyatAyarlar.ekstraKgFiyat} TL/KG</span>
        </div>
      </div>
    </div>
  );
}

export default TartimPage;